import React, {Component} from 'react'
import cn from "classnames"
import PropTypes from "prop-types"
import {PAYPAL_DONATE_LINK} from "../../settings/settings"


class Donate extends Component {
    render() {
        let {formatMessage} = this.context
        return (
            <div className={cn("payment", "payment--flex", "payment--theme-default", "payment--responsive")}>
                <div className={cn([
                    "payment__col",
                    "payment__col__gutter",
                    "text-justify"
                ])}>
                    <div className="payment__thanks payment__thanks--x-y-indent">{formatMessage("We are proudly non-profit, non-corporate and non-compromised. Thousands of people like you help us stand up for all. We rely on donations to carry out our mission to keep the Question Bank Manager open and free. Will you give today?")}!</div>
                    <div className="text-center">
                        <button
                            type="button"
                            className="payment__button"
                            onClick={this.handleClick}
                            style = {{borderRadius : 15}}
                        >{formatMessage("Donate to Question Bank Manager")}</button>
                    </div>
                </div>
            </div>
        )
    }
    handleClick = () => {
        window.open(PAYPAL_DONATE_LINK, '_blank')
    }

    static contextTypes = {formatMessage: PropTypes.any}
}

export default Donate


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Payment/Donate.js